import { useContext } from 'sb-hooks'

import { Context } from './RecurlyProvider'
import type { Recurly } from './RecurlyProvider'


const useRecurly = () => useContext<Recurly>(Context)


export default useRecurly
